module.exports = __webpack_public_path__ + "img/1.73d523d7.jpg";